module.exports = __webpack_public_path__ + "static/media/icon.c338eaba.png";